import React, { useEffect } from 'react'
import SectionHeader from '../../Components/SectionHeader/SectionHeader';
import Event from '../../Components/Event/Event'
import imgStage from '../../assets/UpcomingEvents/Stage.jpg'
import imgSteelWaterConference from '../../assets/UpcomingEvents/SteelWaterConstructionConference.jpg'
import CenterStage from '../../Components/CenterStage/CenterStage';
import imgVDBUMLogo from '../../assets/UpcomingEvents/VDBUM-Logo.jpg'
import imgVDBUM from '../../assets/UpcomingEvents/VDBUM.jpg'
import imgDemolitionLogo from '../../assets/UpcomingEvents/Logo_Fachtagung_Abbruch.png'
import imgDemolition from '../../assets/UpcomingEvents/DemolitionConf.jpg'
import imgBaumaLogo from '../../assets/UpcomingEvents/baumaLogo.png'
import imgBauma from '../../assets/UpcomingEvents/BaumaImage.jpg'

import imgRopaLogo from '../../assets/UpcomingEvents/Ropa_Logo.png'
import imgRopaImage from '../../assets/UpcomingEvents/RopaImage.jpg'
import imgCoreumLogo from '../../assets/UpcomingEvents/COREUM_Logo_2.png'
import imgCoremImage from '../../assets/UpcomingEvents/CoreumImage.jpg'
import imginnotranLogo from '../../assets/UpcomingEvents/innotranLogo.png'
import imgInnoTransImage from '../../assets/UpcomingEvents/InnoTransImage.jpg'


const UpcomingEvents = () => {
    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to top on component mount
    }, []);
    const futureEventsData = [
        {
            eventDate: {
                start: "2025-02-11",
                end: "2025-02-12",
                year: "2025"
            },
            eventTitle: "Steel Water Construction Conference",
            eventDescription: "The 22nd SWB Conference 2025 will focus on the current challenges and future prospects of the municipal utility industry. Topics such as digitization, sustainability and innovative energy solutions are in the foreground in order to prepare municipal utilities and suppliers for the future. Our team will also be on site to provide information about our innovations and industry-related services.",
            eventLocation: "Bremen",
            eventLink: "https://teubert-kommunikation.de/swb-tagung/",
            eventImages: [
                {
                    // src: imgVDBUMLogo,
                    // alt: "2010_07_JA_Wasserbau_0691.jpg"
                },
                {
                    src: imgSteelWaterConference,
                    alt: "2010_07_JA_Wasserbau_0691.jpg"
                }
            ]
        },
        {
            eventDate: {
                start: "2025-02-11",
                end: "2025-02-14",
                year: "2025"
            },
            eventTitle: "VDBUM major seminar",
            eventDescription: "The VDBUM major seminar is an important event for the construction, environmental and mechanical engineering sectors. It offers a platform for exchanging information on current technologies, innovations and practical solutions, with expert lectures and demonstrations taking center stage. We will also be there again for the 53rd event.",
            eventLocation: "Willingen",
            eventLink: "https://vdbum.de/grossseminar/53-vdbum-grossseminar-2025/",
            eventImages: [
                {
                    src: imgVDBUMLogo,
                    alt: "VDBUM Logo"
                },
                {
                    src: imgVDBUM,
                    alt: "VDBUM Sauerland Stern-Hotel sign in snow"
                }
            ]
        },
        {
            eventDate: {
                start: "2025-03-14",
                end: "2025-03-14",
                year: "2025"
            },
            eventTitle: "Demolition Conference",
            eventDescription: "The Demolition 2025 conference will take place on March 14, 2025 in Berlin and has the motto 'Quality in Demolition'. The event offers specialist lectures, discussions and a trade exhibition on topics related to the demolition industry. We are delighted to be there!",
            eventLocation: "Berlin",
            eventLink: "https://www.fachtagung-abbruch.de/",
            eventImages: [
                {
                    src: imgDemolitionLogo,
                    alt: "VDBUM Logo"
                },
                {
                    src: imgDemolition,
                    alt: "VDBUM Sauerland Stern-Hotel sign in snow"
                }
            ]
        },
        {
            eventDate: {
                start: "2025-04-07",
                end: "2025-04-13",
                year: "2025"
            },
            eventTitle: "BAUMA 2025",
            eventDescription: "BAUMA is the leading international trade fair for construction machinery, construction vehicles, construction equipment and mining machinery. The entire construction industry comes together at the trade fair and we are looking forward to days full of exchange, insights and connections!",
            eventLocation: "Munich, open-air area 808/1",
            eventLink: "https://bauma.de/de/messe/",
            eventImages: [
                {
                    src: imgBaumaLogo,
                    alt: "VDBUM Logo"
                },
                {
                    src: imgBauma,
                    alt: "VDBUM Sauerland Stern-Hotel sign in snow"
                }
            ]
        },
    ];

    const pastEventsData = [
        {
            eventDate: {
                start: "2024-10-13",
                end: "2024-10-13",
                year: "2024"
            },
            eventTitle: "Ropa home demonstration",
            eventDescription: "Experience the latest agricultural technology in action on over 10 hectares at this year's ROPA in-house demonstration. In addition to innovative sugar beet and potato harvesters in field use, you can expect a diverse trade exhibition accompanied by a varied supporting program. Look forward to an exciting day full of machine demonstrations and social gatherings with a folk festival atmosphere!",
            eventLocation: "Viersen-Boisheim",
            // eventLink: "#",
            eventImages: [
                {
                    src: imgRopaLogo,
                    alt: "Ropa Logo"
                },
                {
                    src: imgRopaImage,
                    alt: "Ropa home demonstration"
                }
            ]
        },
        {
            eventDate: {
                start: "2024-10-11",
                end: "2024-10-13",
                year: "2024"
            },
            eventTitle: "Coreum Practice Days",
            eventDescription: "The Coreum practical days are all about getting involved, touching things, experiencing things up close! On the 80,000 square meter site, brands from the construction, material handling, recycling and building construction sectors present their machines and equipment.",
            eventLocation: "Stockstadt am Rhein",
            // eventLink: "#",
            eventImages: [
                {
                    src: imgCoreumLogo,
                    alt: "Coreum Logo"
                },
                {
                    src: imgCoremImage,
                    alt: "Coreum Practice Days"
                }
            ]
        },
        {
            eventDate: {
                start: "2024-09-24",
                end: "2024-09-27",
                year: "2024"
            },
            eventTitle: "InnoTrans",
            eventDescription: "InnoTrans is the leading international trade fair for transport technology, divided into five trade fair segments: Railway Technology, Railway Infrastructure, Public Transport, Interiors and Tunnel Construction. It is organized by Messe Berlin.",
            eventLocation: "Berlin",
            eventLink: "https://www.innotrans.de/",
            eventImages: [
                {
                    src: imginnotranLogo,
                    alt: "InnoTrans Logo"
                },
                {
                    src: imgInnoTransImage,
                    alt: "InnoTrans event"
                }
            ]
        }
    ];

    return (
        <div>
            <CenterStage imageSrc={imgStage} title={"OUR TRADE FAIR APPEARANCES"}
                paragraph={"We are present for you at exciting trade fairs and public exhibitions around the world. Experience the passion of HANSA-FLEX live at the exhibition stands and convince yourself of the variety of products and tailor-made services. We'll see you there - or in one of the 400 branches worldwide!"} />
            <div className="c-events div-gray">
                <SectionHeader title={"UPCOMING FAIRS"}
                    subtitle={"Here we are going in 2025"} />
                {futureEventsData.map((event, index) => (
                    <Event
                        key={index}
                        eventDate={event.eventDate}
                        eventTitle={event.eventTitle}
                        eventDescription={event.eventDescription}
                        eventLocation={event.eventLocation}
                        eventLink={event.eventLink}
                        eventImages={event.eventImages}
                    />
                ))}
            </div>
            <div className="c-events">
                <SectionHeader title={"PAST TRADE FAIRS"}
                    subtitle={"Here we were in 2024"} />
                {pastEventsData.map((event, index) => (
                    <Event
                        key={index}
                        eventDate={event.eventDate}
                        eventTitle={event.eventTitle}
                        eventDescription={event.eventDescription}
                        eventLocation={event.eventLocation}
                        eventLink={event.eventLink}
                        eventImages={event.eventImages}
                    />
                ))}
            </div>
        </div>
    )
}

export default UpcomingEvents